export const GET_ADMIN_IPS = "GET_ADMIN_IPS";
export const REFETCH_ADMIN_IPS = "REFETCH_ADMIN_IPS";
export const CREATE_ADMIN_IPS = "CREATE_ADMIN_IPS";
export const DELETE_ADMIN_IPS = "DELETE_ADMIN_IPS";
export const SET_ADMIN_IPS =  "SET_ADMIN_IPS";